module.exports = __webpack_public_path__ + "img/qrcode-half.8e87a618.png";